import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';
import { getStatusValue } from '../selectors';
import { useSelector } from 'react-redux';
import { EnumProductType } from 'src/types/common/product';

import { reducer } from '../dataDict';

const switchProductHooks = (type) => {
  const _h = useHistory();

  const { uuid } = useSelector(getStatusValue(reducer[type]));
  const urlDict = {
    [EnumProductType.Simple]: 'simpleProduct',
    [EnumProductType.Set]: 'productSet',
    [EnumProductType.Variant]: 'variantProduct',
  };
  useAfterDidMountEffect(() => {
    // console.log(uuid);
    if (uuid) {
      _h.push(`/product/${urlDict[type]}/${uuid}`);
    } else {
      _h.push(`/product/${urlDict[type]}/new`);
    }
  }, [uuid]);
};
export { switchProductHooks };
